import { localTime } from './utc-time';

const formatTimestamp = (timestamp: string) => {
  return localTime(timestamp).format('MM/DD/YYYY, hh:mm:ss A');
};

export default formatTimestamp;
